import template from './referralsTile.html';
import controller from './referralsTileCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    myParam: '<',
  },
};
